import {combineReducers} from 'redux';

import {wizardStep} from 'features/contacts/reducers/wizardStep/wizardStep';
import {prescription} from 'features/contacts/reducers/prescription/prescription';
import {prescriptionValues} from 'features/contacts/reducers/prescriptionValues/prescriptionValues';
import {savePrescriptionApproval} from 'features/contacts/reducers/savePrescriptionApproval/savePrescriptionApproval';
import {selectedBoxOption} from 'features/contacts/reducers/boxOption/boxOption';
import {discountPrice} from 'features/contacts/reducers/discountPrice/discountPrice';
import {subscription} from 'features/cLSubscription/reducers/subscription';
import {reviews} from './reviews/reviews';

export const reducers = {
    wizardStep,
    prescription,
    prescriptionValues,
    savePrescriptionApproval,
    selectedBoxOption,
    discountPrice,
    reviews,
    subscription,
};

export const contactsPdp = combineReducers(reducers);
